import { Injectable, Injector, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import * as CONSTANTS from '../../constants/login/login-remember-me-constant';
import {
  ILoginUserNamePasswordInput,
  LoginAuthWithCredentialsResponse,
  LoginOAuthParams,
  PkceCode
} from '../../models/login';
import { LoginPostWithContinueService } from '../../services/login/data-services/login-post-with-continue/login-post-with-continue-service';
import { LoginPostWithCredService } from '../../services/login/data-services/login-post-with-cred/login-post-with-cred-service';
import { LoginPostWithRememberUserService } from '../../services/login/data-services/login-post-with-remember-user/login-post-with-remember-user-service';
import { SwapAccessTokenService } from '../../services/login/data-services/swap-access-token/swap-access-token-service';
import { LoginRememberMeErrorUtilService } from '../../utils/login/login-remember-me-error-util.service';
import { LoginRememberMeUtilsService } from '../../utils/login/login-remember-me-utils.service';

@Injectable({
  providedIn: 'root'
})
export class PostWithCredentialsFacadeHelperService {
  loginPostWithCred = inject(LoginPostWithCredService);
  loginPostWithContinue = inject(LoginPostWithContinueService);
  loginPostWithRememberUser = inject(LoginPostWithRememberUserService);
  loginRememberMeUtils = inject(LoginRememberMeUtilsService);
  LoginRememberMeErrorUtil = inject(LoginRememberMeErrorUtilService);
  swapAccessToken = inject(SwapAccessTokenService);
  injector = inject(Injector);

  flowId = '';
  encyToken = '';
  uid = '';
  pkceCode = {} as PkceCode;

  assignRememberMeDetails(response: LoginAuthWithCredentialsResponse): void {
    this.encyToken = response.encryptedToken ? response.encryptedToken : '';
    this.uid = response.fingerprint ? response.fingerprint : '';
  }

  private getResponseId(response: LoginAuthWithCredentialsResponse): string {
    return response.id || '';
  }

  handleCredentialsResponse(
    response: LoginAuthWithCredentialsResponse,
    loginOAuthParams: LoginOAuthParams,
    requestInput: ILoginUserNamePasswordInput
  ): Observable<LoginAuthWithCredentialsResponse> {
    if (response.status === CONSTANTS.SHOULD_REMEMBER_USER) {
      return this.loginPostWithRememberUser.loginPostWithRememberUser(
        loginOAuthParams.oauthConfig,
        this.getResponseId(response),
        requestInput
      );
    } else {
      return throwError(response);
    }
  }

  handleRememberMeResponse(
    response: LoginAuthWithCredentialsResponse,
    loginOAuthParams: LoginOAuthParams
  ): Observable<LoginAuthWithCredentialsResponse> {
    if (response.status === CONSTANTS.COMPLETED) {
      return this.swapAccessToken.swapAuthCodeForToken(
        loginOAuthParams,
        response?.authorizeResponse?.code
      );
    } else if (response.status === CONSTANTS.REMEMBERED_DEVICE_DETAILS) {
      this.assignRememberMeDetails(response);
      return this.loginPostWithContinue.loginPostWithContinue(
        loginOAuthParams.oauthConfig,
        this.getResponseId(response)
      );
    } else {
      return throwError(response);
    }
  }
}
